"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiCategory = /** @class */ (function (_super) {
    __extends(ApiCategory, _super);
    function ApiCategory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_LIST = "/api/category/comicList";
        _this.ADD = "/api/category/addComicCategory";
        _this.DELETE = "/api/category/deleteComicCategory";
        _this.CHANGE_SORT = "/api/category/sort";
        _this.ALl_DELETE = "/api/category/emptyList";
        /**
         * category 리스트 획득
         * @param accesstoken
         * @param language
         * @param depth1
         * @param depth2
         * @param depth3
         * @returns
         */
        _this.getCategoryList = function (accesstoken, language, depth1, depth2, depth3) {
            var data = {
                language: language,
                depth1: depth1,
                depth2: depth2 || "",
                depth3: depth3 || "",
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_LIST,
                data: data,
            });
            return config;
        };
        /**
         * 작품에 카테고리 정보를 추가
         * @param language :등록 할려는 언어값 (en/ko)
         * @param comicId  : 만화 식별 ID
         * @param category
         * "category": [
            {
            "depth1": "TEST_DEPTH1",
            "depth2": "TEST_DEPTH2",
            "depth3": "TEST_DEPTH3"
            },
            {
            "depth1": "TEST2_DEPTH1",
            "depth2": "TEST2_DEPTH2",
            "depth3": "TEST2_DEPTH3"
            }
          ]
        */
        _this.addCategory = function (accesstoken, language, comicId, category) {
            var data = {
                language: language,
                comicId: comicId,
                category: category,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.ADD,
                data: data,
            });
            return config;
        };
        /**
         * 카테고리 별 작품 정렬 기능
         * @param accesstoken
         * @param language
         * @param depth1
         * @param depth2
         * @param depth3
         * @param comicIds
         * @returns
         */
        _this.updateCategorySort = function (accesstoken, language, depth1, depth2, depth3, comicIds) {
            var data = {
                language: language,
                depth1: depth1,
                depth2: depth2,
                depth3: depth3,
                comicIds: comicIds,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.CHANGE_SORT,
                data: data,
            });
            return config;
        };
        /**
         * category 삭제
         * @param accesstoken
         * @param language
         * @param comicId
         * @param category
         * @returns
         */
        _this.deleteCategory = function (accesstoken, language, comicId, category) {
            var data = {
                language: language,
                comicId: comicId,
                category: category,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DELETE,
                data: data,
            });
            return config;
        };
        _this.deleteAllCategory = function (accesstoken, language, depth1, depth2, depth3) {
            var data = {
                language: language,
                depth1: depth1,
                depth2: depth2,
                depth3: depth3,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.ALl_DELETE,
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiCategory.getInstance = function (initValue) {
        if (!ApiCategory.classInstance) {
            this.classInstance = new ApiCategory(initValue);
        }
        return this.classInstance;
    };
    return ApiCategory;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiCategory;
